/* PR1 – telefon: tanka linija napretka ispod galerije */
(function(){
  function init(root){
    if(root.dataset.prGallery) return; root.dataset.prGallery='1';
    var list=root.querySelector('.product__media-list'); if(!list) return;
    var slides=list.querySelectorAll(':scope > .product__media-item');
    root.classList.add('pr-progress');
    if(slides.length<2) return;
    var line=document.createElement('div'); line.className='pr-progress-line'; line.setAttribute('aria-hidden','true');
    var bar=document.createElement('span'); bar.style.width=(100/slides.length)+'%'; line.appendChild(bar);
    var slider=list.closest('slider-component')||list; slider.insertAdjacentElement('afterend',line);
    function update(){var w=list.clientWidth||1;var i=Math.round(list.scrollLeft/w);i=Math.max(0,Math.min(slides.length-1,i));bar.style.transform='translateX('+(i*100)+'%)';}
    list.addEventListener('scroll',function(){window.requestAnimationFrame(update)},{passive:true});
    window.addEventListener('resize',update); update();
  }
  function run(){document.querySelectorAll('product-info.elia-pdp').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  document.addEventListener('shopify:section:load',run);
})();
/* PR1 – uvećane (kadrirane) fotografije: učitaj veću verziju slike da ne bude mutno */
(function(){
  function fix(){
    document.querySelectorAll('product-info.elia-pdp .product__media-list .product__media img').forEach(function(img){
      var m=getComputedStyle(img).transform; if(!m||m==='none') return;
      var s=parseFloat(m.split('(')[1]); if(!(s>1.05)) return;
      var w=img.offsetWidth||img.parentElement.clientWidth;
      var want=Math.round(w*s*(window.devicePixelRatio||1));
      if(img.dataset.prSized==String(want)) return; img.dataset.prSized=String(want);
      img.sizes=Math.round(w*s)+'px'; img.loading='eager';
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
  window.addEventListener('load',fix); window.addEventListener('resize',fix);
})();
